/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum StarredObjectType {
  Company = "company",
  Shipment = "shipment",
}

export function instanceOfStarredObjectType(value: any): boolean {
  for (const key in StarredObjectType) {
    if (Object.prototype.hasOwnProperty.call(StarredObjectType, key)) {
      if (StarredObjectType[key as keyof typeof StarredObjectType] === value) {
        return true;
      }
    }
  }
  return false;
}

export function StarredObjectTypeFromJSON(json: any): StarredObjectType {
  return StarredObjectTypeFromJSONTyped(json, false);
}

export function StarredObjectTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): StarredObjectType {
  return json as StarredObjectType;
}

export function StarredObjectTypeToJSON(value?: StarredObjectType | null): any {
  return value as any;
}

export function StarredObjectTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): StarredObjectType {
  return value as StarredObjectType;
}
